import React, { useState, useEffect,useCallback,useMemo } from 'react';
import { debounce } from 'lodash';
import { Link, NavLink, useLocation,useParams } from 'react-router-dom';
import { BiLogoFacebook } from "react-icons/bi";
import { PiPhoneCall, PiInstagramLogoFill, PiYoutubeLogoFill, PiCaretUpDownBold, PiMinusBold } from "react-icons/pi";
import { MdAlternateEmail } from "react-icons/md";
import { GrLocation } from "react-icons/gr";
import { LuHeart } from "react-icons/lu";
import { RiLinkedinFill } from "react-icons/ri";
import { FiArrowUpRight } from "react-icons/fi";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import builerLogo from '../../../assets/images/builders/logos/logo2.svg'
import esightLogo from '../../../assets/images/esight-logo-white.png'
import projectImg1 from '../../../assets/images/builders/builderProjects/img1.webp'
import projectImg2 from '../../../assets/images/builders/builderProjects/img2.webp'
import projectImg3 from '../../../assets/images/builders/builderProjects/img3.webp'
import projectImg4 from '../../../assets/images/builders/builderProjects/img4.webp'
import projectImg5 from '../../../assets/images/builders/builderProjects/img5.webp'
import projectImg6 from '../../../assets/images/builders/builderProjects/img6.webp'
import projectImg7 from '../../../assets/images/builders/builderProjects/img7.webp'
import projectImg8 from '../../../assets/images/builders/builderProjects/img8.webp'
import emptyVideo from '../../../assets/images/empty.mp4'

import axios from 'axios';
import { mediaUrl,baseURL } from '../../axiosInterceptor/axiosInterceptorC';
import { fetchProjects } from "../../slice/websiteProjectSlice";
import { fetchWebsiteById } from "../../slice/websiteSlice";
import { useDispatch, useSelector } from "react-redux";

const path = "/keralaplots/";


function BuilderProjectList() {
    // State to track the selected sort option
    const [isLoading, setIsLoading] = useState(true);
    const [sortOption, setSortOption] = useState("All");
    const dispatch = useDispatch();
    const { companyName } = useParams();
    const location = useLocation();
    const [ChcekPorjects,SetChcekPorjects]=useState('none');

    const isActiveProjects = () => {
        return location.pathname.includes(`/builderProjectList`) || location.pathname.includes(`/builderProject`) ;
    };

    const { data: projects, loading, error } = useSelector((state) => state.projects);
    const { websiteDetails} =useSelector((state) => state.website);


    // useEffect(() => {
    //     dispatch(fetchProjects({ companyName, status: "All" }));
    //     dispatch(fetchWebsiteById(companyName));
    //   }, [dispatch, companyName]);
      

    // const handleSortOptionClick = (option) => {
    //   setSortOption(option);
    //   dispatch(fetchProjects({ companyName, status: option }));
    // };
    
    useEffect(() => {
        dispatch(fetchProjects({ companyName, status: sortOption }));
        dispatch(fetchWebsiteById(companyName));
      }, [dispatch, companyName, sortOption])

    const debouncedFetchProjects = debounce((option) => {
        dispatch(fetchProjects({ companyName, status: option }));
        dispatch(fetchWebsiteById(companyName));
      }, 10); 

      const handleSortOptionClick = useCallback((option) => {
        setSortOption(option);
        debouncedFetchProjects(option);
      }, [debouncedFetchProjects]);
    
      const memoizedProjects = useMemo(() => projects, [projects]);

   /* useEffect(() => {
        localStorage.setItem('companyName',companyName);
        fetch_websitet_by_id();
      }, []); 


    // Function to handle clicking a sort option
    const handleSortOptionClick = (option) => {
        setSortOption(option); // Update the selected sort option
        fetchProjectdetails(option)
        
    };

        //fetch project details
        useEffect(() => {
            fetchProjectdetails()
          }, []); 
          const [projects2, setProjects2] = useState([])

          const fetchProjectdetails = async (option) => {
            try {
            const response = await axios.post(`${baseURL}/builder/fetchprojectDeatils`, {
                companyName: companyName,
                status_val:option
            });
           console.log(response.data)
           if(response.data.length==0){
            SetChcekPorjects('block')
            setIsLoading(false);
           }
           else{
            SetChcekPorjects('none')
            setIsLoading(false);
           }
            setProjects2(response.data);
        }
        catch (error) {
            console.error(error);
        }
    }
        
    
    const [websiteDetails,setwebsiteDetails]=useState([]);

     const fetch_websitet_by_id = async () => {
         const cleanedCompanyName = decodeURIComponent(companyName);
          console.log(cleanedCompanyName)   
          try {
          const response = await axios.post(`${baseURL}/website/fetch_websitet_by_id`, {
              company_name: cleanedCompanyName,
          });
      console.log(response.data)
  
      const websiteDetails=response.data.websiteDetails[0];        
      setwebsiteDetails({
          company_name:websiteDetails.company_name,
          logo_image:websiteDetails.logo_image,
          phone1: websiteDetails.phone_number1,
          phone2: websiteDetails.phone_number2,
          email: websiteDetails.email_id,
          address1:websiteDetails.address_line1,
          address2:websiteDetails.address_line2,
          address3:websiteDetails.address_line3,
          facebook:websiteDetails.facebook_val,
          instagram:websiteDetails.instagram_val,
          youtube:websiteDetails.linkedin_val,
          linkedin:websiteDetails.youtube_val,
          title: websiteDetails.about_title,
          experience: websiteDetails.experience_val,
          description:websiteDetails.about_description,
          });
      }
      catch (error) {
          console.error(error);
      }
  }*/
 

     
  return (
    <>
        <div class="pageLoader"><div class="pageLoaderBox"></div></div>
        <div className="navTemplate">
            <div className="container">
                <div className="navMain">
                    <div className="navCol1">
                        <a href={`${path}${companyName}`} className="navLogo">
                        {websiteDetails.logo_image ? (
                                <img src={mediaUrl + websiteDetails.logo_image} alt="Website Logo" />
                            ) : (
                                <Skeleton width={100} height={50} /> // Placeholder loading effect
                            )}
                        </a>
                    </div>
                    <div className="navCol2">
                        <div className="navLink">
                            <ul>
                                <li>
                                    <NavLink to={`${path}${companyName}`} >Home</NavLink>
                                </li>
                                <li>
                                    <NavLink to={`${path}${companyName}/builderProjectList`} className={() => (isActiveProjects() ? 'navLinkActive' : '')}>Projects</NavLink>
                                </li>
                                <li>
                                    <NavLink to={`${path}${companyName}/builderPropertyList`}>Properties</NavLink>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="navCol3">
                        <div className="navProfile">
                            <NavLink to={`${path}`} target='_blank' className="navPostproperty">Kerala Plots <FiArrowUpRight /></NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <section id="builderProjectList">
            <div className="builderProjectListHead">
                <div className="builderProjectListHeadCol1">
                    <h2>All Projects</h2>
                </div>
                <div className="builderProjectListHeadCol2">
                    <div className="sortBtn">
                        <div className="sortBtnHead">
                            <PiCaretUpDownBold />
                            <p>Sort By :</p>
                            <h3>{sortOption}</h3> {/* Display the selected sort option */}
                        </div>
                        <div className="sortBtnPopup">
                            <ul>
                            {/* List items to select sorting options */}
                            <li onClick={() => handleSortOptionClick("All")}>
                                All
                            </li>
                            <li onClick={() => handleSortOptionClick("Completed")}>
                                Completed
                            </li>
                            <li onClick={() => handleSortOptionClick("On Going")}>
                                On Going
                            </li>
                            <li onClick={() => handleSortOptionClick("Just Launched")}>
                                Just Launched
                            </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="builderProjectListMain">
                {loading ? (
                    <div className="projectSkeletonLoader">
                    {[...Array(1)].map((_, index) => (
                        <div className="builderProjectListBox skeleton" key={index}>
                        <div className="builderProjectListBoxThumbnail">
                            <Skeleton height={180} />
                        </div>
                        <div className="builderProjectListBoxDetails">
                            <Skeleton height={20} width="80%" />
                            <Skeleton height={15} width="60%" />
                        </div>
                        </div>
                    ))}
                    </div>
                ) : memoizedProjects.length > 0 ? (
                    memoizedProjects.map((project) => (
                    <a
                        key={project.id}
                        href={`${path}${companyName}/builderProject/${project.id}`}
                        className="builderProjectListBox"
                    >
                        <div className="builderProjectListBoxThumbnail">
                        <img
                            src={project.image ? mediaUrl + project.image : projectImg8}
                            alt={project.project_name}
                        />
                        <div className="builderProjectListBoxTag">{project.project_status}</div>
                        </div>
                        <div className="builderProjectListBoxDetails">
                        <h3>{project.project_name}</h3>
                        <p>{project.location_val}</p>
                        </div>
                    </a>
                    ))
                ) : (
                    // ✅ Show Empty Page when there are no projects
                    <div className="emptyPage">
                    <div className="container">
                        <div className="emptyPageMain">
                        <div className="emptyPageBoxThumbnail">
                            <video playsInline preload="auto" autoPlay muted loop>
                            <source src={emptyVideo} type="video/mp4" />
                            </video>
                        </div>
                        <div className="emptyPageBoxDetails">
                            <h2 className="title">No matches found!</h2>
                            <p>
                            But your perfect place is out there! 🏡 Try adjusting your filters or expanding your search to
                            discover more options.!
                            </p>
                        </div>
                        </div>
                    </div>
                    </div>
                )}
                </div>

        </section>
        <div className="footerTemplate">
            <div className="container">
                <div className="footerMain">
                    <div className="footerBox1">
                        <div className="footerLogo">
                        {websiteDetails.logo_image ? (
                                <img src={mediaUrl + websiteDetails.logo_image} alt="Website Logo" />
                            ) : (
                                <Skeleton width={100} height={50} /> // Placeholder loading effect
                            )}
                        </div>
                        <div className='footerSocialLink'>
                            <Link href={websiteDetails.facebook} target='_blank' className='footerSocialLinkBox'>
                                <BiLogoFacebook />
                            </Link>
                            <Link href={websiteDetails.instagram} target='_blank' className='footerSocialLinkBox'>
                                <PiInstagramLogoFill />
                            </Link>
                            <Link href={websiteDetails.linkedin} target='_blank' className='footerSocialLinkBox'>
                                <RiLinkedinFill />
                            </Link>
                            <Link href={websiteDetails.youtube} target='_blank' className='footerSocialLinkBox'>
                                <PiYoutubeLogoFill />
                            </Link>
                        </div>
                    </div>
                    <div className="footerBox2">
                        <h2>Links</h2>
                        <ul>
                            <li>
                                <NavLink to={`${path}${companyName}`}><span></span>Home</NavLink>
                            </li>
                            <li>
                                <NavLink to={`${path}${companyName}/builderProjectList`}><span></span>Projects</NavLink>
                            </li>
                            <li>
                                <NavLink to={`${path}${companyName}/builderPropertyList`}><span></span>Properties</NavLink>
                            </li>
                        </ul>
                    </div>
                    <div className="footerBox3">
                        <h2>Connect Us</h2>
                        <ul>
                            <li>
                                <div className='icon'>
                                    <PiPhoneCall />
                                </div>
                                <div className='contactDestails'>
                                    <Link href={`tel:+91${websiteDetails.phone1}`}>+91 {websiteDetails.phone1}</Link>
                                </div>
                            </li>
                            <li>
                                <div className='icon'>
                                    <MdAlternateEmail />
                                </div>
                                <div className='contactDestails'>
                                    <Link href={`mailto:${websiteDetails.email}`}>{websiteDetails.email}</Link>
                                </div>
                            </li>
                            <li>
                                <div className='icon'>
                                    <GrLocation />
                                </div>
                                <div className='contactDestails'>
                                <p>{websiteDetails.address1} <br/>{websiteDetails.address2}<br/>{websiteDetails.address3}</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className='footerStrip'>
                    <div className='footerStripBox'>
                        <p>Copyright © 2025 keralaplots. All Rights Reserved.</p>
                    </div>
                    <div className='footerStripBox'>
                        <p>Designed with</p>
                        <LuHeart />
                        <Link to="https://esightsolutions.com/" target='_blank' className='footerStripLogo'>
                            <img src={esightLogo} alt="" />
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </>
  );
}

export default BuilderProjectList;
